import React, { Component } from 'react';
import { showWhenPermission } from '@/shared/components/security';
import AssignmentAnalysisMatrix from '@/modules/hrm/assignmentAnalysis/AssignmentAnalysisMatrix';

class AssignmentAnalysisEmployeeRelationMatrix extends Component {
  render() {
    return <AssignmentAnalysisMatrix matrixType="relation" />;
  }
}

export default showWhenPermission(
  'CapacityPlanning',
  'read',
)(AssignmentAnalysisEmployeeRelationMatrix);
